import { SET_DATA_KEY } from '../../../../workout-exercise/model/constants'

function hasCircuitRestWorkoutSectionUtil (set, roundSet) {
  return (
    set &&
    set[SET_DATA_KEY.REST] ==
    null &&
    roundSet &&
    roundSet[SET_DATA_KEY.REST] !=
    null
  )
}

export { hasCircuitRestWorkoutSectionUtil }
